import { createAction } from 'redux-actions';
import { pushModal } from '@wix/da-shared-react/pkg/Modals/redux/basicActions';
import { DreamupFormModals } from '../../constants';
import { reduxKey } from './constants';
export const reduxInitialized = createAction(`${reduxKey}.REDUX_INITIALIZED`, ()=>({}));
export const initializeForm = createAction(`${reduxKey}.INITIALIZE_FORM`, (data, options)=>({
        data,
        options
    }));
export const changePrompt = createAction(`${reduxKey}.CHANGE_PROMPT`, (prompt)=>({
        prompt
    }));
export const clearPrompt = createAction(`${reduxKey}.CLEAR_PROMPT`, ()=>({}));
export const changeSimilarity = createAction(`${reduxKey}.CHANGE_SIMILARITY`, (similarity)=>({
        similarity
    }));
export const changePromptStrength = createAction(`${reduxKey}.CHANGE_PROMPT_STRENGTH`, (promptStrength)=>({
        promptStrength
    }));
export const changeAspectRatio = createAction(`${reduxKey}.CHANGE_ASPECT_RATIO`, (aspectRatio)=>({
        aspectRatio
    }));
export const changeArtStyle = createAction(`${reduxKey}.CHANGE_ART_STYLE`, (artStyle)=>({
        artStyle
    }));
/**
 * Sets up the UI and state to accept a variation generation request.
 */ export const startVariation = createAction(`${reduxKey}.START_VARIATION`, (deviation, options)=>({
        deviation,
        options
    }));
/**
 * Clears the variation specific UI elements and state.
 */ export const clearVariation = createAction(`${reduxKey}.CLEAR_VARIATION`, ()=>({}));
export const toggleNegativePrompt = createAction(`${reduxKey}.TOGGLE_NEGATIVE_PROMPT`, ()=>({}));
export const changeNegativePrompt = createAction(`${reduxKey}.CHANGE_NEGATIVE_PROMPT`, (negativePrompt)=>({
        negativePrompt
    }));
/**
 * Shows a settings panel with advanced generation options
 */ export const showPromptSettingsPanel = createAction(`${reduxKey}.SHOW_PROMPT_SETTINGS_PANEL`, ()=>({}));
export const hidePromptSettingsPanel = createAction(`${reduxKey}.HIDE_PROMPT_SETTINGS_PANEL`, ()=>({}));
export const showStartingImageSelector = createAction(`${reduxKey}.SHOW_STARTING_IMAGE_SELECTOR`, ()=>({}));
export const hideStartingImageSelector = createAction(`${reduxKey}.HIDE_STARTING_IMAGE_SELECTOR`, ()=>({}));
export const generateFromPrompt = createAction(`${reduxKey}.GENERATE_FROM_PROMPT`, (usePoints)=>({
        usePoints
    }));
export const generationFromPromptInitiationSucceeded = createAction(`${reduxKey}.GENERATION_FROM_PROMPT_INITIATION_SUCCEEDED`, (generationId, imageCount, restrictions)=>({
        generationId,
        imageCount,
        restrictions
    }));
export const generationFromPromptInitiationFailed = createAction(`${reduxKey}.GENERATION_INITIATION_FAILED`, (error, serverErrorMessage)=>({
        error,
        serverErrorMessage
    }));
/**
 * If any actions outside the form involve spending a resource (e.g. prompt, points), we need to update the value
 * over here.
 */ export const updateRestrictions = createAction(`${reduxKey}.UPDATE_RESTRICTIONS`, (restrictions)=>({
        restrictions
    }));
export const loadPersistentFormValues = createAction(`${reduxKey}.LOAD_PERSISTENT_FORM_VALUES`, ()=>({}));
export const storeFormValuesForRedirectPersistence = createAction(`${reduxKey}.STORE_FORM_VALUES_FOR_REDIRECT_PERSISTENCE`, ()=>({}));
export const pushPointsModal = ()=>pushModal(DreamupFormModals.POINTS, {
        wrapInModal: false
    });

//# sourceMappingURL=actions.js.map